<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Mietvertrag erneut versenden

  section.modal-card-body
    ValidationObserver(ref="form")
      div
        .container2
          .two-column
            .column
              h2.title.is-6 E-Mail Anhang
              iframe(ref="pdf-preview").pdf-preview
            .column(v-if="formData.sendCustomerEmail")
              .form.w640
                h2.title.is-6 Gast E-Mail
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subject")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.body" :editorOptions="editorOptions")
              .spacer.sm
              //- .form.w640
                h2.title.is-6 Optionale Einleitung
                ValidationProvider(name="Optionale Einleitung" rules="" v-slot="{ errors, valid }") 
                  b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.optionalOfferText" type="textarea")
                b-button(type="is-light" @click="generatePDF()") PDF aktualisieren
            .column(v-if="formData.sendOwnerEmail")
              .form.w640
                h2.title.is-6 Eigentümer E-Mail
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subjectOwner")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.bodyOwner" :editorOptions="editorOptions")
      
  footer.modal-card-foot
    .button-wrapper.max.right
      button.button.is-gray(@click="$emit('close')") Abbrechen
      .spacer.lg.inline
      b-checkbox(v-model="formData.sendCustomerEmail") Gast E-Mail senden
      b-checkbox(v-model="formData.sendOwnerEmail") Eigentümer E-Mail senden
    //- button.button.is-secondary(@click="sendContract()") Speichern ohne Senden
    .spacer.lg
    button.button.is-primary(@click="sendEmail()" :disabled="!formData.sendCustomerEmail && !formData.sendOwnerEmail") Senden & Speichern
</template>

<script>
export default {
  props: {
    booking: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        subject: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        body: null,
        subjectOwner: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        bodyOwner: null,
        optionalOfferText: null,
        sendCustomerEmail: true,
        sendOwnerEmail: false
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  async mounted() {
    this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
    const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
    let contractTemplate = emailTemplates.find(e => e.uuid === 'CONTRACT_EMAIL');
    let contractOwnerTemplate = emailTemplates.find(e => e.uuid === 'CONTRACT_OWNER_EMAIL');
    const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractTemplate, booking: {...this.fullBooking, ...this.calcTotalPrices({...this.fullBooking, ...this.bookingInformation?.items})}});
    const resultOwner = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractOwnerTemplate, booking: {...this.fullBooking, ...this.calcTotalPrices({...this.fullBooking, ...this.bookingInformation?.items})}});
    this.formData.subject = result.template.subject;
    this.formData.body = result.template.body;
    this.formData.subjectOwner = resultOwner.template.subject;
    this.formData.bodyOwner = resultOwner.template.body;
    this.generatePDF();
  },
  methods: {
    async generatePDF() {
      const loadingComponent = this.$buefy.loading.open();

      const pdfArraybuffer = await this.$store.dispatch('contracts/getAttachement', {id: this.fullBooking.parentContract.contracts[this.fullBooking.parentContract.contracts.length - 1].id});
      const pdfBlob = new Blob([pdfArraybuffer], { type: "application/pdf" });
      this.$refs["pdf-preview"].src = URL.createObjectURL(pdfBlob);
      
      loadingComponent.close();
    },
    sendEmail() {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        await this.$store.dispatch("emails/resend", {...this.formData,
                                                    rentObjectBookingId: this.booking.id,
                                                    inboxDate: new Date(),
                                                    contractId: this.fullBooking.parentContract.contracts[this.fullBooking.parentContract.contracts.length - 1].id});
        loadingComponent.close();
        
        this.$emit('refreshInbox');
        this.$emit('close');

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    calcTotalPrices(booking) {
      const prices = {
        totalRentPrice: 0,
        totalItemPrice: 0
      }
      for (let i = 0; i < booking.bookingItems.length; i += 1) {
        if (booking.bookingItems[i].referenceColumnName === 'rentObjectPrices') {
          prices.totalRentPrice += booking.bookingItems[i].totalPrice;
        }
        if (booking.bookingItems[i].referenceColumnName === 'rentObjectBookingExtras') {
          prices.totalItemPrice += booking.bookingItems[i].totalPrice;
        }
      }
      return prices;
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>